<template>
    <activation-delivered-content-provider v-slot="{ task, isLoading, errors, errorMessage, content, goToContent }">
        <activation-delivered-content-view
            :task="task"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :content="content"
            @go-to-content="goToContent"
        />
    </activation-delivered-content-provider>
</template>

<script>
    import ActivationDeliveredContentProvider from '../providers/activation-brief-steps/ActivationDeliveredContentProvider.vue';
    import ActivationDeliveredContentView from '../data-views/activation-briefs/partials/tasks/ActivationDeliveredContentView.vue';

    export default {
        name: 'ActivationDeliveredContentRouterView',
        components: {
            ActivationDeliveredContentProvider,
            ActivationDeliveredContentView
        }
    };
</script>
